import type { MilestoneKind } from '../../domain/types';

/**
 * One picture per kind of simcha (see MILESTONE_KINDS). Shared by the chooser
 * in the Add sheet, the line on the timeline and the milestone's own gallery,
 * so a wedding looks like a wedding everywhere in the app.
 */
export const MILESTONE_ICONS: Record<MilestoneKind, string> = {
  wedding: 'heart', engagement: 'heart', birth: 'cake', brit: 'sparkle', barMitzvah: 'magen', batMitzvah: 'magen',
  graduation: 'graduation', newHome: 'home', aliyah: 'world', anniversary: 'heart', memorial: 'candles', other: 'milestone',
};

/**
 * And one colour per family of simcha, so the timeline can be read by colour
 * before it is read at all: gold for a marriage, blue for a bar or bat mitzvah,
 * green for a new life, orange for a move or a graduation, grey for the quiet
 * ones. Stories are teal and a birth is green — see `TONE` in TimelineScreen.
 *
 * The names are deliberately colour words rather than meanings: the CSS
 * (`.tl-node.is-gold`) maps each to a token, and nothing else needs to agree.
 */
export type MilestoneTone = 'gold' | 'teal' | 'blue' | 'green' | 'orange' | 'grey';

export const MILESTONE_TONES: Record<MilestoneKind, MilestoneTone> = {
  wedding: 'gold', engagement: 'gold', anniversary: 'gold',
  birth: 'green', brit: 'green',
  barMitzvah: 'blue', batMitzvah: 'blue',
  graduation: 'orange', newHome: 'orange', aliyah: 'orange',
  memorial: 'grey', other: 'grey',
};
